import type { JSX } from 'react';

import { highlightParts } from './highlightParts';

import styles from './RecordSearch.module.css';

/** `text` with the part that matches `query` in bold. */
export function Highlight({ text, query }: { text: string; query: string }): JSX.Element {
  const { before, match, after } = highlightParts(text, query);
  if (!match) return <>{text}</>;
  return (
    <>
      {before}
      <mark className={styles.Mark}>{match}</mark>
      {after}
    </>
  );
}
